import { Component, h } from 'preact'
import flatpickr from 'flatpickr'
import { Instance } from 'flatpickr/dist/types/instance'
import Icon from '../assets'
import classnames from 'classnames'

interface Props {
  classes?: string[]
  error?: boolean
  value?: Date
  onChange: (dates: Date[]) => void
  allowPastDates?: boolean
  allowRange?: boolean
  disableInput?: boolean
  isBrand?: boolean
  maxDate?: Date
  defaultDateRange?: Date[]
}

const fpConfig = {
  minDate: 'today',
  altInput: true,
  altFormat: 'M d, Y',
  allowInput: true,
  allowRange: false,
  static: true,
  nextArrow: `<svg width="7" height="10" viewBox="0 0 7 10" fill="#333333" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.3332 0L0.158203 1.175L3.97487 5L0.158203 8.825L1.3332 10L6.3332 5L1.3332 0Z"/>
      </svg>`,
  prevArrow: `<svg width="7" height="10" viewBox="0 0 7 10" fill="#333333" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.8415 1.175L5.6665 0L0.666504 5L5.6665 10L6.8415 8.825L3.02484 5L6.8415 1.175Z"/>
      </svg>`
}

const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
] as const
export default class DatePicker extends Component<Props> {
  private input: HTMLInputElement | null = null
  private currentDateSpan: HTMLSpanElement | null = null
  private closed: number = 0
  private instance: Instance | null = null

  componentShouldUpdate() {
    return false
  }

  componentWillUpdate(nextProps: Props) {
    if (this.instance && nextProps.defaultDateRange) {
      if (
        !isNaN(nextProps.defaultDateRange[0].getTime()) &&
        !isNaN(nextProps.defaultDateRange[1].getTime())
      ) {
        this.instance.setDate(nextProps.defaultDateRange)
      }
    }
  }

  componentDidMount(): void {
    if (this.input) {
      const {
        onChange,
        value,
        allowPastDates,
        disableInput,
        allowRange,
        maxDate,
        defaultDateRange
      } = this.props
      flatpickr(this.input, {
        ...fpConfig,
        minDate: allowPastDates ? undefined : fpConfig.minDate,
        maxDate: allowRange ? maxDate : undefined,
        mode: allowRange ? 'range' : 'single',
        defaultDate: allowRange ? defaultDateRange : value,
        inline: disableInput,
        onReady: (selectedDates, dateStr, instance) => {
          this.instance = instance
          const { currentMonth, currentYear, monthsDropdownContainer, currentYearElement } =
            instance

          this.currentDateSpan = document.createElement('span')
          this.currentDateSpan.classList.add('current-date')
          this.currentDateSpan.innerHTML = `${this.getMonthName(currentMonth)} ${currentYear}`

          monthsDropdownContainer.replaceWith(this.currentDateSpan)
          currentYearElement.parentElement?.remove()

          if (this.props.isBrand) {
            document.querySelector('.flatpickr-calendar')?.classList.add('brand')
          }
        },
        onMonthChange: (selectedDates, dateStr, instance) => {
          this.updateMonthAndYearElement(instance)
        },
        onChange: (selectedDates, dateStr, instance) => {
          this.updateMonthAndYearElement(instance)
          onChange(selectedDates)
        },
        onClose: () => (this.closed = Date.now())
      })
    }
  }

  toggleOpen() {
    Date.now() - this.closed > 200 && this.instance?.open()
  }

  getMonthName(monthIndex: number) {
    return MONTH_NAMES[monthIndex]
  }

  updateMonthAndYearElement(instance: Instance) {
    const { currentMonth, currentYear } = instance
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.currentDateSpan!.innerHTML = `${this.getMonthName(currentMonth)} ${currentYear}`
  }

  render() {
    const { error, classes, disableInput, allowRange } = this.props
    const additionalClasses = classes || []
    return (
      <div
        className={classnames(
          { 'validation-error': error },
          'control-date-picker-input-wrapper',
          ...additionalClasses
        )}
      >
        {!disableInput && (
          <a onClick={() => this.toggleOpen()}>
            <Icon customClass='icon-calendar' icon='calendar' />
          </a>
        )}
        {!disableInput && (
          <a onClick={() => this.toggleOpen()}>
            <Icon customClass='icon-dropdown' width={16} icon='chevronDown' />
          </a>
        )}
        <input
          className={classnames('control-date-picker', {
            'input-hidden': disableInput && !allowRange
          })}
          placeholder='Select a date'
          ref={(input: HTMLInputElement) => (this.input = input)}
        />
      </div>
    )
  }
}
